export type BookingNotifyChannel = 'email' | 'whatsapp';

export const DEFAULT_BOOKING_NOTIFY_CHANNELS: BookingNotifyChannel[] = ['email'];

export function parseBookingNotifyChannels(raw: unknown): BookingNotifyChannel[] {
  if (!Array.isArray(raw)) return [...DEFAULT_BOOKING_NOTIFY_CHANNELS];
  const channels = raw.filter(
    (value): value is BookingNotifyChannel => value === 'email' || value === 'whatsapp',
  );
  return channels.length > 0 ? channels : [...DEFAULT_BOOKING_NOTIFY_CHANNELS];
}

export function toggleBookingNotifyChannel(
  current: BookingNotifyChannel[],
  channel: BookingNotifyChannel,
): BookingNotifyChannel[] {
  if (current.includes(channel)) {
    const next = current.filter((c) => c !== channel);
    return next.length > 0 ? next : [...DEFAULT_BOOKING_NOTIFY_CHANNELS];
  }
  return [...current, channel];
}

export function bookingNotifyUsesEmail(channels: BookingNotifyChannel[]): boolean {
  return channels.includes('email');
}

export function bookingNotifyUsesWhatsApp(channels: BookingNotifyChannel[]): boolean {
  return channels.includes('whatsapp');
}

export function formatBookingNotifySummary(
  channels: BookingNotifyChannel[],
  businessName: string,
): { title: string; body: string } {
  const email = bookingNotifyUsesEmail(channels);
  const whatsapp = bookingNotifyUsesWhatsApp(channels);

  if (email && whatsapp) {
    return {
      title: 'Email & WhatsApp',
      body: `We will email ${businessName} and send you a copy. WhatsApp will also open so you can send them your booking details right away. No online payment — the business will confirm final pricing.`,
    };
  }

  if (whatsapp) {
    return {
      title: 'WhatsApp notification',
      body: `After you submit, WhatsApp will open with your booking details for ${businessName}. We'll save your request on ShopGND.`,
    };
  }

  return {
    title: 'Email confirmation',
    body: `We will email ${businessName} and send you a copy. No online payment — the business will confirm final pricing.`,
  };
}
